module.exports = __webpack_public_path__ + "static/media/Pangoro_gaussian2.2b66dae0.png";